import * as tslib_1 from "tslib";
import m from 'mithril';
import { Image, ImageResizer } from '../ui/image';
import { View } from '../ui/view';
import { classes } from '../util/classes';
var WIDTHS = [100, 200, 400, 600, 800];
var HEIGHTS = [100, 200, 400, 600, 800];
export function getResizedUrl(url, width, height) {
    var w = WIDTHS.find(function (w) { return w > width; });
    var h = HEIGHTS.find(function (h) { return h > height; });
    if (!w)
        w = WIDTHS[WIDTHS.length - 1];
    if (!h)
        h = HEIGHTS[HEIGHTS.length - 1];
    return "/cache/" + w + "/" + h + url;
}
var Picture = /** @class */ (function (_super) {
    tslib_1.__extends(Picture, _super);
    function Picture() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Picture.prototype.render = function () {
        var _a = this.attrs, children = _a.children, inline = _a.inline, className = _a.class, max = _a.max, empty = _a.empty, position = _a.focus, rest = tslib_1.__rest(_a, ["children", "inline", "class", "max", "empty", "focus"]);
        if (empty)
            return;
        return m(ImageResizer, {
            resize: function (attrs, container) {
                var src = attrs.src;
                if (src.indexOf('://') > -1)
                    return attrs;
                var url = getResizedUrl(src, container.width, Infinity);
                return tslib_1.__assign({}, attrs, { src: url });
            }
        }, m(Image, tslib_1.__assign({ upScale: true, position: position, style: { display: inline && 'inline' } }, classes('picture', className), rest)));
    };
    return Picture;
}(View));
export { Picture };
